module.exports = __webpack_public_path__ + "img/heroImg2.d45d65e7.jpeg";